<div class="layout-container center-content">
  <div class="result-card">
    <h2 class="result-title">Match Complete</h2>

    @if (points() < 5){
      <p class="result-subtitle">Keep going!</p>
    }
    @else if (points() >= 5 && points() < 10){
      <p class="result-subtitle">Great job!</p>
    }
    @else{
      <p class="result-subtitle">Outstanding!</p>
    }

    <div class="primary-stat">
      <span class="label">Points</span>
      <span class="value">{{points()}}</span>
    </div>

    <div class="secondary-stats">
      
      <div class="stat-card">
        <span class="stat-label">Passes</span>
        <span class="stat-value">{{tot_passes - passes()}} / {{tot_passes}}</span>
      </div>

      <div class="stat-card">
        <span class="stat-label">Doubles</span>
        <span class="stat-value">{{tot_doubles - doubles()}} / {{tot_doubles}}</span>
      </div>

    </div>

    <button class="action-button primary large" (click)="playAgain()">Play Again</button>
  </div>
</div>
